import history from '../history';
import qs from 'qs';

const getQueryString = () => qs.parse(location.search, { allowDots: true, ignoreQueryPrefix: true });

const setQueryString = (queryString) =>
    history.replace({ search: qs.stringify(queryString, { allowDots: true, arrayFormat: 'repeat' }) });

const getFiltersInQueryString = () => {
    const queryString = getQueryString();
    return queryString.filters || {};
};

const flattenFilters = (filters) => {
    // A few of our filters have unique ways of modeling themselves,
    // we want to flatten these before adding them to the URL
    // TODO: should we integrate this with the Segment flattening?

    const flattened = { ...filters.refinementList };
    if (filters.sliderPricePosLow) {
        flattened.priceFrom = filters.sliderPricePosLow;
    }
    if (filters.sliderPricePosHigh) {
        flattened.priceTo = filters.sliderPricePosHigh;
    }

    // Perform some cleanup of empty values
    for (const param of Object.keys(flattened)) {
        if (!flattened[param]) {
            delete flattened[param];
        }
    }

    return flattened;
};

const queryParametersToFilters = (params) => {
    const { priceFrom, priceTo, ...refinementList } = params;
    const filters: any = {}; // type "any" because it should accept any parameter by design

    if (refinementList && Object.keys(refinementList).length) {
        filters.refinementList = {};
        // RefinementList values should all be arrays
        for (const [key, value] of Object.entries(refinementList)) {
            filters.refinementList[key] = typeof value === 'string' ? [value] : value;
        }
    }

    if (priceFrom) {
        filters.sliderPricePosLow = parseFloat(priceFrom);
    }

    if (priceTo) {
        filters.sliderPricePosHigh = parseFloat(priceTo);
    }

    return filters;
};

export const getQueryParameter = (param: string) => {
    const queryString = getQueryString();
    return queryString[param];
};

export const setQueryParameters = (params: {}) => {
    const queryString = getQueryString();
    for (const param of Object.keys(params)) {
        if (params[param]) {
            queryString[param] = params[param];
        } else {
            delete queryString[param];
        }
    }
    setQueryString(queryString);
};

export const setNewTabInQueryString = (tab: string) => {
    const queryString = getQueryString();
    delete queryString.filters;
    delete queryString.pfilters;
    queryString.tab = tab;
    setQueryString(queryString);
};

export const getDateRangeFromQueryString = () => {
    const queryString = getQueryString();
    return queryString.pfilters?.dateRange?.toLowerCase();
};

export const setDateRangeInQueryString = (dateRange) => {
    const queryString = getQueryString();

    // Date range is a pseudo-filter (not attached to a facet) so
    // it should never be updated in urlUtils except when a new tab
    // is set, otherwise we let the DateList component manage it

    if (!queryString.pfilters) {
        queryString.pfilters = {};
    }
    if (dateRange) {
        queryString.pfilters.dateRange = dateRange;
    } else {
        delete queryString.pfilters.dateRange;
    }
    setQueryString(queryString);
};

export const updateFiltersInQueryString = (filters) => {
    const queryString = { ...getQueryString(), filters: { ...flattenFilters(filters) } };
    setQueryString(queryString);
};

export const getFiltersFromQueryString = () => {
    const filterQueryString = getFiltersInQueryString();
    const filters = queryParametersToFilters(filterQueryString);
    if (Object.keys(filters).length) {
        return filters;
    }
};
